import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { ButtonGlobotComponent } from 'src/app/shared/components/button-globot/button-globot.component';

@Component({
  selector: 'globot-button-steps',
  standalone: true,
  templateUrl: './button-globot-steps.component.html',
  imports: [NgClass, NgIf, ButtonGlobotComponent],
  styleUrls: ['./button-globot-steps.component.scss'],
})
export class ButtonGlobotStepsComponent {
  @Input() visibleBack: boolean = false;
  @Input() visibleNext: boolean = false;
  @Input() visibleCenter: boolean = false;

  @Input() textBack: string = '';
  @Input() textNext: string = '';

  isMobile = window.innerWidth < 768;

  //Emiter
  @Output() clickBack: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickNext: EventEmitter<any> = new EventEmitter<any>();

  style: string = '';

  onClickBackEvent(event: any): void {
    this.clickBack.emit(event);
  }

  onClickNextEvent(event: any): void {
    this.clickNext.emit(event);
  }

}
